import React from 'react';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import type { StatsGranularity } from '../../services/types';

/** Eine Option der Granularitaets-Umschaltung. */
interface GranularityOption {
  readonly value: StatsGranularity;
  readonly label: string;
}

const OPTIONS: readonly GranularityOption[] = [
  { value: 'day', label: 'Tag' },
  { value: 'week', label: 'Woche' },
  { value: 'month', label: 'Monat' },
  { value: 'year', label: 'Jahr' },
];

/** Props der GranularityToggle-Komponente. */
interface GranularityToggleProps {
  /** Aktuell gewaehlte Granularitaet. */
  readonly value: StatsGranularity;
  /** Callback bei Auswahl einer anderen Granularitaet. */
  readonly onChange: (granularity: StatsGranularity) => void;
}

/**
 * Umschaltung der Zeitreihen-Granularitaet (Tag | Woche | Monat | Jahr)
 * als Bootstrap-ButtonGroup. Der aktive Button ist btn-primary, alle
 * anderen btn-outline-primary.
 */
function GranularityToggle({ value, onChange }: GranularityToggleProps): React.JSX.Element {
  return (
    <ButtonGroup id="granularity-toggle" aria-label="Granularität">
      {OPTIONS.map((option) => (
        <Button
          key={option.value}
          id={`granularity-${option.value}`}
          variant={option.value === value ? 'primary' : 'outline-primary'}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </ButtonGroup>
  );
}

export default GranularityToggle;
